export default __webpack_public_path__ + "static/media/beginnerStockMarket.e6a5280a.jpg";